import { ChangeDigitalSignatureProcessClientRequest } from '../../../@types/ChangeDigitalSignatureProcess'
import { EMAIL_OPTION_CODE } from '../../../Components/Confirmation/Expanded'
import { useContextStore } from '../../../Stores/contextStore'
import { useDigitalSignatureSettingsStore } from '../../../Stores/digitalSignature/useDigitalSignatureSettingsStore'
import { useAgent } from '../../../Stores/useAgent'
import { useCreateProposalStore } from '../../../Stores/useCreateProposalStore'
import { useGetAdditionalEntityDetailsStore } from '../../../Stores/useGetAdditionalEntityDetailsStore'
import { useSendDigitalSignatureStore } from '../../../Stores/useSendDigitalSignatureStore'

export const useChangeDigitalSignatureProcessPayload = () => {
  const { agentIdBySessionStorage } = useAgent()
  const { globalContext } = useContextStore()
  const { sendDigitalSignature } = useSendDigitalSignatureStore()
  const { createProposal } = useCreateProposalStore()
  const { policyholderAdditionalDetails } = useGetAdditionalEntityDetailsStore()
  const { signatureTypeSelected, settings, OTPData } =
    useDigitalSignatureSettingsStore()

  const isSMSSignature =
    signatureTypeSelected?.signatureType === EMAIL_OPTION_CODE
  const email =
    OTPData?.email || policyholderAdditionalDetails?.emailContact?.email || ''
  const phone =
    OTPData?.phone ||
    policyholderAdditionalDetails?.phoneContactList?.[0]?.phoneNumber ||
    ''

  const handleChangeDigitalSignatureProcessPayload = () => {
    const payload: ChangeDigitalSignatureProcessClientRequest = {
      signatureId: sendDigitalSignature?.digitalSignature?.signatureId || '',
      user: globalContext?.username || '',
      mediationAccount: agentIdBySessionStorage || '',
      digitalSignature: {
        policyId: createProposal?.createProposalResponse?.proposalId,
        participant:
          settings?.participants?.map((item) => ({
            signatureType: signatureTypeSelected?.signatureType || '',
            participantId: item.participantId || '',
            participantEmail: isSMSSignature
              ? email
              : item.participantEmail || '',
            participantPhoneNumber: isSMSSignature
              ? phone
              : item.participantPhoneNumber || '',
            signaturePosition:
              item?.signaturePosition?.map((signaturePosition) => ({
                documentId: signaturePosition.documentId || 0,
                page: signaturePosition.page || 1,
                xPosition: signaturePosition.xPosition || 0,
                yPosition: signaturePosition.yPosition || 0,
                width: signaturePosition.width || 0,
                height: signaturePosition.height || 0,
                required: signaturePosition.required || true,
              })) || [],
          })) || [],
      },
    }

    return payload
  }

  return {
    handleChangeDigitalSignatureProcessPayload,
  }
}
